import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import { Carousel, Button, Modal } from "antd";
import { FaHeart } from "react-icons/fa"; // Import FontAwesome Heart icon
import { useHistory } from "react-router-dom";
import arrowleft from "../Images/arrowleft.png";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import axios from "axios";
import ArrowDown from "../Images/ArrowDown.png";
import { AppContext, useAppContext } from "./../AppContext";
import { useLocation, useParams } from "react-router-dom";
import SimilarProductsComp from "./ProductDiscComponents/SimilarProductsComp";
import AllCategoriesRecentlyViewed from "./AllCategoriesComponents/AllCategoriesRecentlyViewed";
import PerfumeBlockTwoCards from "../PerfumeBlockComponents/PerfumeBlockTwoCards";
import AllCategoriesCartDialog from "./AllCategoriesComponents/AllCategoriesCartDialog";
import LottifileLoading from "../LottifileLoading.json";
import Lottie from "lottie-react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import CloseImg from "../Images/CloseImg.png";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import ProductDiscReviews from "./ProductDiscComps/ProductDiscReviews";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const BootstrapDialog2 = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "90%",

    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const BootstrapDialog3 = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "70%"
        : window.innerWidth <= 1920
        ? "50%"
        : window.innerWidth <= 2560
        ? "60%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const BootstrapDialogBuyNotLogin = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "90%"
        : window.innerWidth <= 1920
        ? "40%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "50%"
        : "40%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
export default function ProductDisc() {
  const { t, i18n } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));

  const [FirstName, setFirstName] = useState(user?.firstName);
  const [Email, setEmail] = useState(user?.email);
  const [TheText, setTheText] = useState("");
  const [value, setValue] = React.useState(0);
  const [openDone, setOpenDone] = React.useState(false);

  const [OpenRateProductDialog, setOpenRateProductDialog] = useState(false);

  const [MyOpen, setMyOpen] = React.useState(false);
  const { setOpenLoginPopOver, OpenLoginPopOver } = useAppContext();
  const handleOpenDialog = () => {
    setMyOpen(true);
  };

  const handleCloseDialog = () => {
    setMyOpen(false);
  };
  const [MobileColorDropDownButton, setMobileColorDropDownButton] = useState(0);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();
  const [RecommendedProductsData, setRecommendedProductsData] = useState([]);
  const [currentSlide2, setCurrentSlide2] = useState(0);
  const carouselRef2 = React.createRef();
  const { CartAmount, setCartAmount } = useContext(AppContext);
  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const GetRecommendedProducts = () => {
    setRecommendedProductsData([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}RecommendedProducts/GetRecommendedProductsById`, data)
      .then((response) => {
        console.log(response.data);
        setRecommendedProductsData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    GetRecommendedProducts();
  }, []);
  const handleDivClick3 = (NewsCodeCat) => {
    history.push({
      pathname: `/news/${NewsCodeCat}`,
      state: TheObject, // Pass CategoryName here
    });
  };
  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };
  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);
    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        // Update cart data in state
        setCartData(response.data);
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        // Calculate total price with discount logic
        const totalPrice = userCart.reduce((accumulator, cartItem) => {
          const product = products.find((p) => p.id === cartItem.idOfProduct);
          if (product) {
            const { price, discount, theDeal } = product;
            const { amountOfProduct } = cartItem;
            let total = 0;
            if (theDeal === 1) {
              // Apply discount to all items
              total += price * (1 - discount / 100) * amountOfProduct;
            } else {
              // Apply discount only to every nth item
              for (let i = 1; i <= amountOfProduct; i++) {
                if (i % theDeal === 0) {
                  total += price * (1 - discount / 100);
                } else {
                  total += price;
                }
              }
            }
            return accumulator + total;
          }
          return accumulator; // If no matching product, skip
        }, 0);
        setSaveTotalPrice(totalPrice);
        setCartAmount(response.data.userCart.length);
      })
      .catch((error) => {
        console.log("Error adding product to cart:", error);
      });
  };
  const wrapperRef2 = useRef();
  const handleBeforeChange2 = (from, to) => {
    setCurrentSlide2(to);
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page when component mounts
  }, []);

  // Update window size when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Dynamically calculate width based on the window size
  // const imageWidth = windowSize.width > 1000 ? 1000 : windowSize.width * 0.8; // 80% of the window width, max 1000px
  const imageWidth = windowSize.width > 1200 ? 500 : 300;

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // Default selected option
  const dropdownRef = useRef(null); // Reference to the dropdown

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false); // Close the dropdown after selecting
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if the click is outside the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);
  const { ProductId } = useParams(); // Get ProductId from the URL

  const [ProductId2, setProductId2] = useState(ProductId); // State to store product data

  const [productData, setProductData] = useState(null); // State to store product data
  const [TheProduct, setTheProduct] = useState(null); // State to store product data
  const [theProductHover, setTheProductHover] = useState(null); // State to store product data

  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling
  const [ProductsData, setProductsData] = useState([]);
  const [CheckIfInWishList, setCheckIfInWishList] = useState([]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [CartData, setCartData] = useState([]);
  const [ImagesOfProduct, setImagesOfProduct] = useState([]);
  const [HideIndexesOfImages, setHideIndexesOfImages] = useState([]);
  const [SaveIndexFromDropDown, setSaveIndexFromDropDown] = useState(0);
  const [SimilarProducts, setSimilarProducts] = useState([]);
  const [GetCards, setGetCards] = useState({});
  const [DoLoading, setDoLoading] = useState(false);
  const [TheObject, setTheObject] = useState("");
  const [DoLoading2, setDoLoading2] = useState(false);
  const [ReviewsProduct, setReviewsProduct] = useState([]);
  const [NumberUsersReview, setNumberUsersReview] = useState(0);
  const [ListOfUsersReview, setListOfUsersReview] = useState([]);
  const AllCategoriesRecentlyViewedComp = useMemo(() => {
    return (
      <>
        <AllCategoriesRecentlyViewed />
      </>
    );
  }, []);

  const SimilarProductsCompComp = useMemo(() => {
    return (
      <>
        <SimilarProductsComp SimilarProducts={SimilarProducts} />
      </>
    );
  }, [SimilarProducts]);
  // useEffect(() => {
  //   setProductId2(ProductId);
  //   if (user === null) {
  //     const fetchProductData = async () => {
  //       try {
  //         const data = {
  //           ProductId: ProductId,
  //         };
  //         const response = await axios.post(
  //           `${MyDomain}Products/GetProductAndWishListByIdWhenLogOut`,
  //           data
  //         );
  //         const averageRating = Math.floor(
  //           response.data.reviewsProduct.reduce(
  //             (sum, item) => sum + item.rating,
  //             0
  //           ) / response.data.reviewsProduct.length
  //         );
  //         setReviewsProduct(averageRating);
  //         setNumberUsersReview(response.data.reviewsProduct.length);
  //         setListOfUsersReview(response.data.reviewsProduct);
  //         console.log(averageRating);
  //         setDoLoading(false);
  //         console.log(response.data?.categoryName);
  //         const CheckData =
  //           response.data.categoryName?.filter((item) => item.itsRun === 1) ||
  //           [];

  //         setGetCards(
  //           CheckData.filter(
  //             (item) => item.whichPlace === 0 || item.whichPlace === 12
  //           )
  //         );
  //         setProductsData(response.data.products);
  //         const product = response.data.products.find(
  //           (p) => p.id === p.productId
  //         );
  //         const fetchProductData2 = async () => {
  //           try {
  //             setDoLoading2(false);
  //             axios
  //               .post(`${MyDomain}News/GetOneNews2`, product.newsCodeCat, {
  //                 headers: {
  //                   "Content-Type": "application/json", // Ensure the server knows the payload type
  //                 },
  //               })
  //               .then((response) => {
  //                 setTheObject(response.data);
  //               })
  //               .catch((err) => {
  //                 console.log(err.response.data);
  //               });
  //           } catch (err) {
  //           } finally {
  //             setDoLoading2(true);
  //           }
  //         };

  //         fetchProductData2();
  //         console.log(product);
  //         setTheProduct(product);
  //         setSimilarProducts(response.data.similarProducts);
  //         setSelectedOption(product.dropDown);
  //         const names = response.data.products.map((item) => item.image);
  //         const names2 = response.data.productsImages.map(
  //           (item) => item.mainImage
  //         );
  //         const productIndices = response.data.products.map(
  //           (_, index) => index
  //         );
  //         setHideIndexesOfImages(productIndices);
  //         setImagesOfProduct(names.concat(names2));
  //         setProductData(response.data.products); // Save data to state
  //       } catch (err) {
  //         setError("Failed to fetch product data");
  //       } finally {
  //         setLoading(false); // Stop loading
  //         setDoLoading(true);
  //       }
  //     };

  //     fetchProductData();
  //   } else {
  //     const fetchProductData = async () => {
  //       try {
  //         const data = {
  //           UserId: user?.userId,
  //           ProductId: ProductId,
  //         };

  //         const response = await axios.post(
  //           `${MyDomain}Products/GetProductAndWishListById`,
  //           data
  //         ); // replace with your API URL
  //         console.log(response.data.reviewsProduct);
  //         const averageRating = Math.floor(
  //           response.data.reviewsProduct.reduce(
  //             (sum, item) => sum + item.rating,
  //             0
  //           ) / response.data.reviewsProduct.length
  //         );
  //         setReviewsProduct(averageRating);
  //         setNumberUsersReview(response.data.reviewsProduct.length);
  //         setListOfUsersReview(response.data.reviewsProduct);

  //         console.log(averageRating);

  //         setDoLoading(false);
  //         console.log(response.data?.categoryName);

  //         const CheckData =
  //           response.data.categoryName?.filter((item) => item.itsRun === 1) ||
  //           [];

  //         setGetCards(
  //           CheckData.filter(
  //             (item) => item.whichPlace === 0 || item.whichPlace === 12
  //           )
  //         );
  //         setProductsData(response.data.products);
  //         const product = response.data.products.find(
  //           (p) => p.id === p.productId
  //         );
  //         console.log(product.newsCodeCat);
  //         const fetchProductData2 = async () => {
  //           try {
  //             setDoLoading2(false);
  //             axios
  //               .post(`${MyDomain}News/GetOneNews2`, product.newsCodeCat, {
  //                 headers: {
  //                   "Content-Type": "application/json", // Ensure the server knows the payload type
  //                 },
  //               })
  //               .then((response) => {
  //                 console.log(response.data);
  //                 setTheObject(response.data);
  //               })
  //               .catch((err) => {
  //                 console.log(err.response.data);
  //               });
  //           } catch (err) {
  //           } finally {
  //             setDoLoading2(true);
  //           }
  //         };

  //         fetchProductData2();

  //         setTheProduct(product);
  //         setSimilarProducts(response.data.similarProducts);

  //         setSelectedOption(product.dropDown);
  //         setCheckIfInWishList(response.data.wishList);
  //         // Extracting names into a new array
  //         const names = response.data.products.map((item) => item.image);
  //         const names2 = response.data.productsImages.map(
  //           (item) => item.mainImage
  //         );
  //         const productIndices = response.data.products.map(
  //           (_, index) => index
  //         );
  //         setHideIndexesOfImages(productIndices);
  //         setImagesOfProduct(names.concat(names2));
  //         setProductData(response.data.products); // Save data to state
  //       } catch (err) {
  //         setError("Failed to fetch product data");
  //       } finally {
  //         setLoading(false); // Stop loading
  //         setDoLoading(true);
  //       }
  //     };

  //     fetchProductData();
  //   }
  // }, [ProductId]); // Dependency array ensures it runs when ProductId changes

  // Custom hook to preload images
  const usePreloadedImages = (images) => {
    const [areImagesLoaded, setAreImagesLoaded] = useState(false);

    useEffect(() => {
      if (!images || images.length === 0) {
        setAreImagesLoaded(false);
        return;
      }

      let loadedCount = 0;
      const imageElements = [];

      images.forEach((src) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            setAreImagesLoaded(true);
          }
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            setAreImagesLoaded(true); // Even if some images fail
          }
        };
        imageElements.push(img);
      });

      // Cleanup
      return () => {
        imageElements.forEach((img) => {
          img.onload = null;
          img.onerror = null;
        });
      };
    }, [images]);

    return areImagesLoaded;
  };

  const areImagesLoaded = usePreloadedImages(ImagesOfProduct);

  useEffect(() => {
    const fetchProductDetails = async (responseData) => {
      try {
        const reviews = responseData.reviewsProduct || [];
        const averageRating = reviews.length
          ? Math.floor(
              reviews.reduce((sum, item) => sum + item.rating, 0) /
                reviews.length
            )
          : 0;

        setReviewsProduct(averageRating);
        setNumberUsersReview(reviews.length);
        setListOfUsersReview(reviews);
        setDoLoading(false);

        const filteredCategories = (responseData.categoryName || []).filter(
          (item) => item.itsRun === 1
        );
        setGetCards(
          filteredCategories.filter(
            (item) => item.whichPlace === 0 || item.whichPlace === 12
          )
        );

        setProductsData(responseData.products);
        setProductData(responseData.products); // save to state

        const product = responseData.products.find((p) => p.id === p.productId);
        if (product) {
          await fetchNewsData(product.newsCodeCat);
          setTheProduct(product);
          console.log(product);
          setSelectedOption(product.dropDown);
        }

        setSimilarProducts(responseData.similarProducts);

        const productImages = responseData.products.map((item) => item.image);
        const additionalImages = responseData.productsImages.map(
          (item) => item.mainImage
        );
        const productIndices = responseData.products.map((_, index) => index);
        setHideIndexesOfImages(productIndices);
        setImagesOfProduct(productImages.concat(additionalImages));
      } catch (error) {
        console.error("Error processing product details:", error);
      }
    };

    const fetchNewsData = async (newsCodeCat) => {
      try {
        setDoLoading2(false);
        const response = await axios.post(
          `${MyDomain}News/GetOneNews2`,
          newsCodeCat,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        setTheObject(response.data);
      } catch (err) {
        console.error("Failed to fetch news data:", err?.response?.data || err);
      } finally {
        setDoLoading2(true);
      }
    };

    const fetchProductData = async () => {
      try {
        setProductId2(ProductId);

        const data = user ? { UserId: user.userId, ProductId } : { ProductId };

        const endpoint = user
          ? `${MyDomain}Products/GetProductAndWishListById`
          : `${MyDomain}Products/GetProductAndWishListByIdWhenLogOut`;

        const response = await axios.post(endpoint, data);
        await fetchProductDetails(response.data);

        if (user) {
          setCheckIfInWishList(response.data.wishList);
        }
      } catch (err) {
        console.error("Error fetching product data:", err);
        setError("Failed to fetch product data");
      } finally {
        setLoading(false);
        setDoLoading(true);
      }
    };

    if (ProductId) {
      fetchProductData();
    }
  }, [ProductId]);

  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    console.log(TheObject === "" ? console.log("yes") : console.log("no"));
    if (TheObject === "") {
    } else {
      const interval = setInterval(() => {
        const [day, month, year] = TheObject.dateEnd?.split("-");
        const targetDate = new Date(`${year}-${month}-${day}T00:00:00`);
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          setTimeLeft("The date has passed.");
          clearInterval(interval);
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        setTimeLeft(
          `${t("profile.Specialofferwillendin")} ${days} ${t(
            "profile.days"
          )} ${t("profile.and")} ${hours}:${minutes}:${seconds}`
        );
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [TheObject.dateEnd]);

  const [clickedHearts, setClickedHearts] = useState(
    Array(ProductsData.length).fill(false)
  );

  const productDropDowns1 = ProductsData.map((item) => item);
  const [LoadingClickBuyButton, setLoadingClickBuyButton] = useState(false);

  const CreateProduct = (event) => {
    setLoadingClickBuyButton(true);
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: TheProduct.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        setCartData(response.data);
        setCartAmount(response.data.userCart.length);
        handleClickOpen(response.data);
        setLoadingClickBuyButton(false);
        console.log(response.data);
      })
      .catch((err) => {
        setLoadingClickBuyButton(false);

        console.log(err.response.data);
      });
  };
  const handleClickOpen = async (NewData) => {
    setCartData(NewData);
    const userCart = NewData?.userCart || [];
    const products = NewData?.products || [];
    // Safely calculate total price with discount logic
    const totalPrice = userCart.reduce((accumulator, cartItem) => {
      const product = products.find((p) => p.id === cartItem.idOfProduct);

      if (product) {
        const { price } = product;
        const { amountOfProduct } = cartItem;
        let total = 0;

        if (product.theDeal === 1) {
          // Apply discount to all items
          total += price * (1 - product.discount / 100) * amountOfProduct;
        } else {
          // Apply discount only to every nth item
          for (let i = 1; i <= amountOfProduct; i++) {
            if (i % product.theDeal === 0) {
              total += price * (1 - product.discount / 100);
            } else {
              total += price;
            }
          }
        }

        // Add the total for this product to the accumulator
        return accumulator + total;
      }
      return accumulator; // If no matching product, skip
    }, 0);

    setSaveTotalPrice(totalPrice);
    handleOpenDialog();
    //setOpen(true);
  };
  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };
  const { WishList, setWishList } = useAppContext();

  const DeleteFromWishList = async (TheId) => {
    axios
      .delete(`${MyDomain}WishList/DeleteFromWishList`, {
        data: { ProductId: TheProduct.id, UserId: user?.userId },
      })
      .then((response) => {
        setWishList(response.data);

        let updatedWishlist;
        updatedWishlist = CheckIfInWishList.filter(
          (item) =>
            item.productId !== TheProduct.id && item.userId === user?.userId
        );
        setCheckIfInWishList(updatedWishlist);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const AddProductToWishList = async (event) => {
    const data = {
      ProductId: TheProduct.id,
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}WishList/AddProductToWishList`, data) // replace with your API URL
      .then((response) => {
        let updatedWishlist;
        updatedWishlist = [
          ...CheckIfInWishList,
          { userId: user?.userId, productId: TheProduct.id },
        ];
        setCheckIfInWishList(updatedWishlist);
        setWishList(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const toggleWishlist = async () => {
    const productExists = CheckIfInWishList.some(
      (item) => item.productId === TheProduct.id
    );
    if (productExists) {
      await DeleteFromWishList();
    } else {
      // If product does not exist, add it
      await AddProductToWishList();
    }
  };

  const [activeIndex, setActiveIndex] = useState(0); // Track the current image index
  const [activeIndex2, setActiveIndex2] = useState(0); // Track the current image index

  const handleButtonClick = (index) => {
    setActiveIndex(index); // Set the active image index
  };
  const handleButtonClick2 = (index) => {
    setActiveIndex2(index); // Set the active image index
  };

  const [openImage, setOpenImage] = useState(false);
  const handleClose3 = () => {
    setOpenImage(false);
  };
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setPosition({ x, y });

    setCursorPosition({
      x: e.pageX - left,
      y: e.pageY - top,
    });
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "500px",
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
    display: "block",
  };
  const [ImageUrlForZoom, setImageUrlForZoom] = useState("");

  const magnifierStyle = {
    position: "absolute",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    border: "3px solid #fff",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    pointerEvents: "none",
    zIndex: 10,
    left: `${cursorPosition.x - 100}px`,
    top: `${cursorPosition.y - 100}px`,
    backgroundImage: `url(${ImageUrlForZoom})`,
    backgroundPosition: `${position.x}% ${position.y}%`,
    backgroundSize: `${100 * 3}% ${100 * 3}%`,
    display: showMagnifier ? "block" : "none",
  };

  function ModalOpenImage() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog2
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={openImage}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <IconButton
              aria-label="close"
              onClick={handleClose3}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(90vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                {MyWidth <= 1024 ? (
                  <></>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "10%",
                      flexDirection: "column",
                    }}
                  >
                    {ImagesOfProduct.map((image, index) => (
                      <>
                        <button
                          key={index}
                          onClick={() => {
                            handleButtonClick2(index);
                            handleButtonClick(index);
                          }}
                          style={{
                            padding: "5px",
                            border: "0.5px solid black",
                            cursor: "pointer",
                            backgroundColor: "white",
                            borderColor:
                              index === activeIndex2 ? "black" : "#ccc",
                          }}
                        >
                          <img
                            key={index}
                            src={image}
                            alt={`Image ${index + 1}`} // Using index + 1 to make the alt text more readable
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                            onClick={() => {
                              setImageUrlForZoom(image);
                            }}
                          />
                        </button>
                      </>
                    ))}
                  </div>
                )}

                {MyWidth <= 1024 ? (
                  <div
                    ref={wrapperRef2}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "50vh", // Adjust as needed
                    }}
                  >
                    <Carousel
                      arrows={false}
                      infinite={false}
                      ref={carouselRef2}
                      beforeChange={handleBeforeChange2}
                      //dots={false}
                      style={{
                        width: "100%", // Ensure the carousel takes full width
                        maxWidth: "400px", // Limit the carousel width
                      }}
                    >
                      {ImagesOfProduct.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex !important", // Force flex display
                            justifyContent: "center !important", // Force horizontal centering
                            alignItems: "center !important", // Force vertical centering
                            height: "400px", // Set a fixed height for the slide
                            width: "100%", // Ensure the slide takes full width
                          }}
                        >
                          <img
                            src={ImagesOfProduct[index]}
                            alt={`Image ${index + 1}`}
                            style={{
                              maxHeight: "100%",
                              maxWidth: "100%",
                              objectFit: "contain", // Ensure the full image is visible
                            }}
                            onClick={() => {}}
                          />
                        </div>
                      ))}
                    </Carousel>
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        width: MyWidth <= 1024 ? "100%" : "90%",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: MyWidth <= 1024 ? "100%" : "50%",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            width: MyWidth <= 1024 ? 300 : 500,
                            height: MyWidth <= 1024 ? 300 : 500,
                            overflow: "hidden",
                            margin: "0 auto 20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              transform: `translateX(-${activeIndex * 500}px)`,
                              transition: "transform 0.5s ease-in-out",
                              width: `${ImagesOfProduct.length * 500}px`,
                            }}
                          >
                            {ImagesOfProduct.map((image, index) => (
                              <div style={containerStyle}>
                                <img
                                  src={ImagesOfProduct[index]}
                                  alt="Product"
                                  style={{
                                    // width: "100%",
                                    // height: "auto",
                                    // display: "block",
                                    height: MyWidth <= 1024 ? 250 : 500,
                                    width: "100%",
                                    objectFit: "contain",
                                  }}
                                  onMouseEnter={() => setShowMagnifier(true)}
                                  onMouseLeave={() => setShowMagnifier(false)}
                                  onMouseMove={handleMouseMove}
                                />
                                <div style={magnifierStyle} />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </BootstrapDialog2>
        </React.Fragment>
      </div>
    );
  }
  const [BuyNotLogin, setBuyNotLogin] = useState(false);

  const CloseModalBuyNotLogin = () => {
    setBuyNotLogin(false);
  };
  const ModalBuyNotLogin = () => {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialogBuyNotLogin
            onClose={CloseModalBuyNotLogin}
            aria-labelledby="customized-dialog-title"
            open={BuyNotLogin}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={CloseImg}
                alt="logo"
                style={{
                  minWidth: "30px", // Adjust the size
                  height: "30px", // Adjust the size
                  //borderRadius: "50%", // Makes the image circular
                  //paddingLeft: 200,
                  marginRight: 10,
                  marginTop: 10,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setBuyNotLogin(false);
                }}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>{t("profile.Pleaseloginfirsttopurchasethisproduct")}</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    setBuyNotLogin(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Ok")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialogBuyNotLogin>
        </React.Fragment>
      </div>
    );
  };
  if (loading)
    return (
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          paddingTop: 50,
        }}
      >
        <Lottie
          style={{ height: 40, width: 40 }}
          animationData={LottifileLoading}
        />
      </div>
    );

  if (error) return <p>{error}</p>;

  const handleDivClick = (CategoryTitle, NameOfCategory) => {
    history.push({
      pathname: `/allcategories/${NameOfCategory}`,
      state: { CategoryTitle }, // Pass CategoryName here
    });
  };

  const WindowsForm = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 30,
            paddingBottom: 50,
          }}
        >
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Lemaq
            </Link>
            <Link
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDivClick(
                  TheProduct.category,
                  TheProduct.bigCategoryFilter.split(",")[0].trim()
                );
              }}
              underline="hover"
              color="inherit"
            >
              {TheProduct.category}
            </Link>
            <Typography sx={{ color: "text.primary" }}>
              {TheProduct.name}
            </Typography>
          </Breadcrumbs>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            //justifyContent: "space-between",
            //alignItems: "center",
            direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "30%",
              //backgroundColor: "yellow",
              justifyContent: "center",
            }}
          >
            <div>
              <div
                style={{
                  display: "inline-flex", // Use inline-flex to size by content
                  margin: 0,
                  backgroundColor: "#27272a",
                  transition: "color 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "10px",
                    color: "white",
                    // padding:
                    //   TheProduct.deals === "Deal"
                    //     ? 5
                    //     : TheProduct.deals === "Hit"
                    //     ? 5
                    //     : 0,
                    // paddingLeft:
                    //   TheProduct.deals === "Deal"
                    //     ? 10
                    //     : TheProduct.deals === "Hit"
                    //     ? 10
                    //     : 0,
                    // paddingRight:
                    //   TheProduct.deals === "Deal"
                    //     ? 10
                    //     : TheProduct.deals === "Hit"
                    //     ? 10
                    //     : 0,

                    padding: TheProduct.deals !== "" ? 5 : 0,
                    paddingLeft: TheProduct.deals !== "" ? 10 : 0,
                    paddingRight: TheProduct.deals !== "" ? 10 : 0,
                    fontWeight: "bold",
                  }}
                >
                  {TheProduct.deals === "ORIGINAL" ? (
                    <>{t("profile.original")}</>
                  ) : TheProduct.deals === "MASTER" ? (
                    <>{t("profile.master")}</>
                  ) : (
                    ""
                  )}
                  {/* {TheProduct.deals} */}
                  {/* {TheProduct.deals === "Deal"
                    ? "D E A L"
                    : TheProduct.deals === "Hit"
                    ? "H I T"
                    : ""} */}
                </p>
              </div>
            </div>
            <p
              style={{ fontSize: 15, margin: 0, opacity: 0.5, paddingTop: 20 }}
            ></p>
            <p style={{ fontSize: 26, fontWeight: "500", margin: 0 }}>
              {TheProduct.name}
            </p>
            <p
              style={{ fontSize: 15, margin: 0, opacity: 0.5, paddingTop: 20 }}
            >
              {TheProduct.productType}
            </p>
            {NumberUsersReview === 0 ? (
              <></>
            ) : (
              <>
                {" "}
                <Rating
                  name="read-only"
                  value={ReviewsProduct}
                  readOnly
                  sx={{
                    // Make stars bigger
                    fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                    // Add space between stars
                    "& .MuiRating-icon": {
                      color: "black", // Black stars
                      paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                      paddingTop: 1,
                    },

                    // Ensure filled/hover stars are also black
                    "& .MuiRating-iconFilled": {
                      color: "black",
                    },
                    "& .MuiRating-iconHover": {
                      color: "black",
                    },
                  }}
                />
              </>
            )}
            {NumberUsersReview !== 0 ? (
              <a style={{ fontSize: 14, opacity: 0.5 }}>
                {NumberUsersReview} {t("profile.Reviews")}
              </a>
            ) : (
              <></>
            )}
            <p
              style={{ fontSize: 15, margin: 0, opacity: 0.5, paddingTop: 20 }}
            ></p>
            {TheProduct.newsCodeCat === 0 ? (
              <></>
            ) : (
              <>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleDivClick3(TheProduct.newsCodeCat);
                  }}
                >
                  <div
                    style={{
                      marginTop: 20,
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <a
                      style={{
                        color: "white",
                        backgroundColor: "#6b21a8",
                        padding: 3,
                        paddingLeft: 8,
                        paddingRight: 8,
                        fontSize: 13,
                      }}
                    >
                      {i18n.language === "en"
                        ? TheObject.typeOfferName
                        : i18n.language === "ar"
                        ? TheObject.typeOfferNameAr
                        : i18n.language === "he"
                        ? TheObject.typeOfferNameHe
                        : TheObject.typeOfferName}
                    </a>
                  </div>
                  <p
                    style={{
                      fontSize: 13,
                      margin: 0,
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <a>
                      {" "}
                      {i18n.language === "en"
                        ? TheObject.disc1
                        : i18n.language === "ar"
                        ? TheObject.disc1Ar
                        : i18n.language === "he"
                        ? TheObject.disc1He
                        : TheObject.disc1}
                    </a>
                  </p>
                </div>
                <a
                  style={{
                    fontSize: 13,
                    direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                  }}
                >
                  {DoLoading && DoLoading2 ? <>{timeLeft}</> : <></>}
                </a>
              </>
            )}
          </div>
          <div
            style={{
              display: "flex",
              width: "40%",
              direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "400px",
                height: "400px",
                overflow: "hidden",
                margin: "0 auto 20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  transform: `translateX(-${activeIndex * 400}px)`,
                  transition: "transform 0.5s ease-in-out",
                  width: `${ImagesOfProduct.length * 400}px`,
                  direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
                }}
              >
                {ImagesOfProduct.map((image, index) => (
                  <>
                    <img
                      key={index}
                      src={image}
                      alt={`Image ${image + 1}`}
                      style={{
                        // width: "400px",
                        // height: "400px",
                        // objectFit: "cover",
                        height: MyWidth <= 1024 ? 200 : 400,
                        width: "100%",
                        objectFit: "contain",
                        cursor: "zoom-in",
                      }}
                      onClick={() => {
                        setImageUrlForZoom(image);
                        setOpenImage(true);
                      }}
                    />
                  </>
                ))}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "30%",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 25,
              }}
            >
              {theProductHover === null ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {TheProduct.discount === 0 ? (
                    <>
                      {TheProduct.priceInsteadOf === 0 ? (
                        <>
                          <a
                            style={{
                              margin: 0,
                              color: TheProduct.theDeal === 1 ? "" : "red",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              TheProduct.price,
                              1,
                              TheProduct.discount,
                              TheProduct.theDeal
                            )}
                          </a>
                        </>
                      ) : (
                        <>
                          <a
                            style={{
                              margin: 0,
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              TheProduct.price,
                              1,
                              TheProduct.discount,
                              TheProduct.theDeal
                            )}
                          </a>
                          &nbsp; ₪{TheProduct.priceInsteadOf}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: TheProduct.theDeal !== 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          TheProduct.price,
                          1,
                          TheProduct.discount,
                          TheProduct.theDeal
                        )}
                      </a>
                    </>
                  )}
                  &nbsp;&nbsp;
                  <p style={{ margin: 0 }}>
                    {TheProduct.theDeal === 1 && TheProduct.discount !== 0 ? (
                      <>
                        <a style={{ margin: 0 }}>
                          <a
                            style={{
                              margin: 0,
                              textDecoration:
                                TheProduct.discount === 0
                                  ? "none"
                                  : "line-through",
                              color: TheProduct.discount === 0 ? "" : "#a1a1aa",
                            }}
                          >
                            {TheProduct.price.toFixed(2)}
                          </a>
                          &nbsp;&nbsp;{" "}
                          <a
                            style={{
                              backgroundColor: "#6b21a8",
                              color: "white",
                              fontSize: 12,
                              paddingLeft: 5,
                              paddingRight: 5,
                            }}
                          >
                            -{TheProduct.discount}%
                          </a>
                        </a>
                      </>
                    ) : (
                      <></>
                    )}
                  </p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {theProductHover.discount === 0 ? (
                    <>
                      {theProductHover.priceInsteadOf === 0 ? (
                        <a
                          style={{
                            margin: 0,
                            color: theProductHover.theDeal === 1 ? "" : "red",
                          }}
                        >
                          ₪
                          {calculateTotalPrice(
                            theProductHover.price,
                            1,
                            theProductHover.discount,
                            theProductHover.theDeal
                          )}
                        </a>
                      ) : (
                        <>
                          <a
                            style={{
                              margin: 0,
                              //color: theProductHover.theDeal === 1 ? "" : "red",
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              theProductHover.price,
                              1,
                              theProductHover.discount,
                              theProductHover.theDeal
                            )}
                          </a>
                          &nbsp;&nbsp;
                          {theProductHover.priceInsteadOf}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: theProductHover.theDeal !== 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          theProductHover.price,
                          1,
                          theProductHover.discount,
                          theProductHover.theDeal
                        )}
                      </a>
                    </>
                  )}
                  &nbsp;&nbsp;
                  <a style={{ margin: 0 }}>
                    {theProductHover.theDeal === 1 &&
                    theProductHover.discount !== 0 ? (
                      <>
                        <a
                          style={{
                            margin: 0,
                            textDecoration:
                              theProductHover.discount === 0
                                ? "none"
                                : "line-through",
                            color:
                              theProductHover.discount === 0 ? "" : "#a1a1aa",
                          }}
                        >
                          {theProductHover.price}
                        </a>
                        &nbsp;&nbsp;{" "}
                        <a
                          style={{
                            backgroundColor: "#6b21a8",
                            color: "white",
                            fontSize: 12,
                            paddingLeft: 5,
                            paddingRight: 5,
                          }}
                        >
                          -{theProductHover.discount}%
                        </a>
                      </>
                    ) : (
                      <></>
                    )}
                  </a>
                </div>
              )}

              {/* Heart icon changes color based on hover and click */}
              <div style={{}}>
                <FaHeart
                  onClick={() => {
                    if (user === null) {
                      setOpenLoginPopOver(true);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    } else {
                      toggleWishlist();
                      const updatedClickedHearts = [...clickedHearts];
                      updatedClickedHearts[TheProduct.id] =
                        !updatedClickedHearts[TheProduct.id]; // Toggle heart state
                      setClickedHearts(updatedClickedHearts); // Update the heart clicked state
                    }
                  }} // Handle heart click
                  style={{
                    cursor: "pointer",

                    fontSize: "18px",
                    color:
                      theProductHover === null
                        ? CheckIfInWishList.some(
                            (item) => item.productId === TheProduct.id
                          )
                          ? "#4f46e5"
                          : "#ccc"
                        : CheckIfInWishList.some(
                            (item) => item.productId === theProductHover.id
                          )
                        ? "#4f46e5"
                        : "#ccc",
                    transition: "color 0.3s ease",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "1px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "transform 0.3s ease, opacity 0.3s ease",
                flexDirection: "column",
              }}
            >
              <div style={{ width: "100%", paddingBottom: 15 }}>
                <div
                  ref={dropdownRef}
                  style={{ position: "relative", display: "flex" }}
                >
                  <button
                    onClick={toggleDropdown}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "white", //"#007bff",
                      color: "white",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent:
                        productDropDowns1.length > 1
                          ? "space-between"
                          : "center",
                      width: "100%",
                      border:
                        productDropDowns1.length > 1
                          ? "1px solid #e4e4e7"
                          : "1px solid #18181b",
                      //border: "1px solid black",
                    }}
                  >
                    <p style={{ color: "black", margin: 0 }}>
                      {selectedOption}
                    </p>
                    <span
                      style={{
                        marginLeft: "10px",
                        display: "inline-block",
                        transition: "transform 0.3s ease", // Smooth transition for the rotation
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate the arrow
                        color: "black",
                      }}
                    >
                      {productDropDowns1.length > 1 ? (
                        <img
                          src={ArrowDown}
                          style={{
                            width: 12,
                            height: 12,
                            opacity: currentSlide === 0 ? 0.3 : 1,
                            cursor: currentSlide === 0 ? "" : "pointer",
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </span>
                  </button>
                  <ul
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      backgroundColor: "white",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      padding: "0",
                      margin: "0",
                      listStyleType: "none",
                      width: "100%",
                      maxHeight: isOpen ? "150px" : "0", // Set max height to limit the size of dropdown
                      overflowY: "auto", // Enable vertical scrolling when content overflows
                      opacity: isOpen ? "1" : "0", // Fade-in/out effect
                      transition: "all 0.3s ease", // Smooth transition for height and opacity
                    }}
                  >
                    <style>
                      {`
                           /* Custom Scrollbar Styling */
                           ul::-webkit-scrollbar {
                             width: 8px;
                           }
                           ul::-webkit-scrollbar-thumb {
                             background-color: #c1c1c1; /* Scrollbar thumb color */
                             border-radius: 4px;
                           }
                           ul::-webkit-scrollbar-thumb:hover {
                             background-color: #a0a0a0; /* Scrollbar thumb hover color */
                           }
                           ul::-webkit-scrollbar-track {
                             background-color: #f1f1f1; /* Scrollbar track color */
                             border-radius: 4px;
                           }
                         `}
                    </style>

                    {productDropDowns1.length > 1 ? (
                      <>
                        {productDropDowns1.map((product, index) => (
                          <li
                            key={product.id}
                            style={{
                              padding: "10px 20px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setProductId2(product.id);
                              handleOptionClick(product.dropDown);
                              setTheProduct(product);
                              handleButtonClick(index);
                              handleButtonClick2(index);
                              setSaveIndexFromDropDown(index);
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#f1f1f1";
                              setTheProductHover(product);
                              handleButtonClick(index);
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "white";
                              setTheProductHover(null);
                            }}
                          >
                            {product.dropDown}
                          </li>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              </div>
              {DoLoading2 ? (
                <>
                  {TheProduct.isGift === 2 ? (
                    <button
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        width: "100%",
                      }}
                      // onClick={() => {
                      //   setOpen(true);
                      // }}
                      onClick={() => {
                        handleDivClick3(TheProduct.newsCodeCat);
                      }}
                    >
                      Receive as a gift
                    </button>
                  ) : (
                    <>
                      <button
                        style={{
                          backgroundColor: "#27272a",
                          color: "#fff",
                          border: "none",
                          padding: "10px 20px",
                          cursor: "pointer",
                          fontSize: "16px",
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        }}
                        // onClick={() => {
                        //   setOpen(true);
                        // }}
                        onClick={() => {
                          user === null
                            ? setBuyNotLogin(true)
                            : CreateProduct();
                        }}
                      >
                        {LoadingClickBuyButton ? (
                          <>
                            {" "}
                            <Lottie
                              style={{ height: 30, width: 30 }}
                              animationData={LottifileLoading}
                            />
                          </>
                        ) : (
                          <>{t("profile.Buy")}</>
                        )}
                      </button>
                    </>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Lottie
                    style={{ height: 30, width: 30 }}
                    animationData={LottifileLoading}
                  />
                </>
              )}
            </div>
            {/* <button style={{ borderWidth: 0, backgroundColor: "black" }}>
            <p style={{ color: "white", margin: 10 }}>Buy</p>
          </button> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingTop: 10,
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              <p style={{ margin: 0 }}>
                {theProductHover === null ? (
                  <>
                    {TheProduct.inStock === "Yes" ? (
                      <>
                        <a style={{ fontSize: 14 }}>{t("profile.InStock")}</a>{" "}
                      </>
                    ) : (
                      <>
                        <a>{t("profile.Outofstock")}</a>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {theProductHover.inStock === "Yes" ? (
                      <>
                        <a>{t("profile.InStock")}</a>{" "}
                      </>
                    ) : (
                      <>
                        <a>{t("profile.Outofstock")}</a>
                      </>
                    )}
                  </>
                )}
              </p>

              <a
                style={{
                  fontSize: 14,
                  paddingRight: 2,
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                {t("profile.productID")}&nbsp;
                <a style={{ color: "#a1a1aa" }}>{ProductId2}</a>
              </a>
            </div>
            <a
              style={{
                fontSize: 14,
                paddingTop: 15,
                color: "#6b21a8",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              {t("profile.Freedeleviryover")}
            </a>
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
          }}
        >
          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
            }}
          >
            {ImagesOfProduct.map((image, index) => (
              <>
                {HideIndexesOfImages.includes(index) ? (
                  <div></div>
                ) : (
                  <>
                    <button
                      key={index}
                      onClick={() => {
                        handleButtonClick2(index);
                        handleButtonClick(index);
                      }}
                      style={{
                        padding: "5px",
                        border: "0.5px solid black",
                        cursor: "pointer",
                        backgroundColor: "white",
                        borderColor: index === activeIndex2 ? "black" : "#ccc",
                      }}
                    >
                      <img
                        key={index}
                        src={image}
                        alt={`Image ${index + 1}`} // Using index + 1 to make the alt text more readable
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                        }}
                      />
                    </button>
                  </>
                )}
              </>
            ))}

            <div
              style={{
                direction: i18n.resolvedLanguage === "en" ? "" : "ltr",

                display: "flex",
                //width: "40%",
                justifyContent: "center",
                alignItems: "center",
                border: "0.5px solid black",
                padding: "5px",
                cursor: "pointer",
                backgroundColor: "white",
                // borderColor:activeIndex2.includes(HideIndexesOfImages)  === 0 ? "black" : "#ccc",
                borderColor: HideIndexesOfImages.includes(activeIndex2)
                  ? "black"
                  : "#ccc",
              }}
              onClick={() => {
                handleButtonClick(SaveIndexFromDropDown);
                handleButtonClick2(SaveIndexFromDropDown);
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "60px",
                  height: "60px",
                  overflow: "hidden",
                  //margin: "0 auto 20px",
                  // backgroundColor: "blue",
                  direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    transform: HideIndexesOfImages.includes(activeIndex2)
                      ? `translateX(-${activeIndex * 60}px)`
                      : "none",
                    transition: HideIndexesOfImages.includes(activeIndex2)
                      ? "transform 0.5s ease-in-out"
                      : "none",
                    width: `${ImagesOfProduct.length * 60}px`,
                    direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
                  }}
                >
                  {ImagesOfProduct.map((image, index) => (
                    <>
                      {HideIndexesOfImages.includes(index) ? (
                        <div style={{}}>
                          <img
                            key={index}
                            src={ImagesOfProduct[SaveIndexFromDropDown]}
                            alt={`Image ${image + 1}`}
                            style={{
                              width: "60px",
                              height: "60px",
                              // objectFit: "cover",
                            }}
                          />
                        </div>
                      ) : (
                        <div style={{}}></div>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100$",
            display: "flex",
            flexDirection: "row",
            marginTop: 80,
            padding: 30,
            border: "0.2px solid #f4f4f5",
          }}
        >
          <div
            style={{
              width: "50%",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <p style={{ fontWeight: "500" }}>{t("profile.Characteristics")}</p>
            <p>{t("profile.Description")}</p>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",

              maxHeight: "300px", // Set maximum height for the dropdown
              overflowY: "auto", // Enable vertical scroll
            }}
          >
            {TheProduct.brand !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Brand")}: </a>
                {TheProduct.brand}
              </a>
            ) : (
              ""
            )}
            {TheProduct.gender !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Gender")}: </a>
                {TheProduct.gender}
              </a>
            ) : (
              ""
            )}
            {TheProduct.topNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.TopNote")}: </a>
                {TheProduct.topNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.productType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProductType")}:{" "}
                </a>
                {TheProduct.productType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.classfication !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.Classification")}:{" "}
                </a>
                {TheProduct.classfication}
              </a>
            ) : (
              ""
            )}
            {TheProduct.productProperties !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProductProperties")}:{" "}
                </a>
                {TheProduct.productProperties}
              </a>
            ) : (
              ""
            )}
            {TheProduct.scentType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.ScentType")}: </a>
                {TheProduct.scentType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.heartNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.HeartNote")}: </a>
                {TheProduct.heartNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.baseNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.BaseNote")}: </a>
                {TheProduct.baseNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.ingredients !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.Ingredients")}:{" "}
                </a>
                {TheProduct.ingredients}
              </a>
            ) : (
              ""
            )}
            {TheProduct.specialCertificates !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.SpecialCertificates")}:{" "}
                </a>
                {TheProduct.specialCertificates}
              </a>
            ) : (
              ""
            )}
            {TheProduct.volume !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Volume")}: </a>
                {TheProduct.volume}
              </a>
            ) : (
              ""
            )}
            {TheProduct.madeIn !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.MadeIn")}: </a>
                {TheProduct.madeIn}
              </a>
            ) : (
              ""
            )}
            {TheProduct.color !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Color")}: </a>
                {TheProduct.color}
              </a>
            ) : (
              ""
            )}
            {TheProduct.protectionLevel !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProtectionLevel")}:{" "}
                </a>
                {TheProduct.protectionLevel}
              </a>
            ) : (
              ""
            )}
            {TheProduct.eyeshadowEffect !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.EyeshadowEffect")}:{" "}
                </a>
                {TheProduct.eyeshadowEffect}
              </a>
            ) : (
              ""
            )}
            {TheProduct.formula !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Formula")}: </a>
                {TheProduct.formula}
              </a>
            ) : (
              ""
            )}
            {TheProduct.country !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Country")}: </a>
                {TheProduct.country}
              </a>
            ) : (
              ""
            )}
            {TheProduct.hairType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.HairType")}: </a>
                {TheProduct.hairType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.brushMaterial !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.BrushMaterial")}:{" "}
                </a>
                {TheProduct.brushMaterial}
              </a>
            ) : (
              ""
            )}
            {TheProduct.skinType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.SkinType")}: </a>
                {TheProduct.skinType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.age !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Age")}: </a>
                {TheProduct.age}
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </>
    );
  };

  const handleButtonClick3 = (index) => {
    if (carouselRef2.current) {
      carouselRef2.current.goTo(index);
    }
  };

  const MobileForm = () => {
    return (
      <div style={{ paddingLeft: "2%", paddingRight: "2%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Vertical Line */}

          <div
            style={{
              //padding: 10,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              //height: "4vh",
            }}
          >
            <img
              src={arrowleft} // Replace with your image URL
              alt="Placeholder"
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
                //borderRadius: "8px",
                cursor: "pointer",
                marginLeft: 10,
              }}
              // onClick={() => {
              //   handleDivClick(NameCat, CodeCat);
              //   scrollToTop2();
              // }}
              onClick={() => {
                handleDivClick(
                  TheProduct.category,
                  TheProduct.bigCategoryFilter.split(",")[0].trim()
                );
              }}
            />
            <div
              style={{
                display: "flex",
                width: "1px",
                height: "100%", // "100%",
                backgroundColor: "#f4f4f5",
                marginRight: 10,
                marginLeft: 10,
              }}
            ></div>
            {/* <AllCategoriesBreadcrumbs
              CodeCat={CodeCat}
              NameCat={NameCat}
              secondNameCat={secondNameCat}
            /> */}

            <Breadcrumbs aria-label="breadcrumb">
              <Link fontSize={12} underline="hover" color="inherit" href="/">
                Lemaq
              </Link>
              <Link
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDivClick(
                    TheProduct.category,
                    TheProduct.bigCategoryFilter.split(",")[0].trim()
                  );
                }}
                underline="hover"
                color="inherit"
                fontSize={12}
                // href={`/allcategories/${TheProduct.bigCategoryFilter
                //   .split(",")[0]
                //   .trim()}`}
              >
                {TheProduct.category}
              </Link>
              <Typography sx={{ color: "text.primary", fontSize: 12 }}>
                {TheProduct.name}
              </Typography>
            </Breadcrumbs>
          </div>
          <div
            style={{
              height: "0.1px",
              backgroundColor: "#f4f4f5",
              width: "100%",
            }}
          ></div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            //justifyContent: "space-between",
            //alignItems: "center",
            //backgroundColor: "gray",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {TheProduct.newsCodeCat === 0 ? (
              <></>
            ) : (
              <>
                <div
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#6d28d9",
                    padding: 10,
                    marginBottom: 20,
                  }}
                  onClick={() => {
                    handleDivClick3(TheProduct.newsCodeCat);
                  }}
                >
                  <p
                    style={{
                      fontSize: 13,
                      margin: 0,
                      color: "white",
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    <a>
                      {" "}
                      {i18n.language === "en"
                        ? TheObject.disc1
                        : i18n.language === "ar"
                        ? TheObject.disc1Ar
                        : i18n.language === "he"
                        ? TheObject.disc1He
                        : TheObject.disc1}
                    </a>
                  </p>
                  <a
                    style={{
                      fontSize: 13,
                      color: "white",
                      direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                    }}
                  >
                    {DoLoading && DoLoading2 ? <>{timeLeft}</> : <></>}
                  </a>
                </div>
              </>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              //backgroundColor: "yellow",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "inline-flex", // Use inline-flex to size by content
                  margin: 0,
                  backgroundColor: "#27272a",
                  transition: "color 0.3s ease",
                  cursor: "pointer",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "10px",
                    color: "white",
                    // padding:
                    //   TheProduct.deals === "Deal"
                    //     ? 5
                    //     : TheProduct.deals === "Hit"
                    //     ? 5
                    //     : 0,
                    // paddingLeft:
                    //   TheProduct.deals === "Deal"
                    //     ? 10
                    //     : TheProduct.deals === "Hit"
                    //     ? 10
                    //     : 0,
                    // paddingRight:
                    //   TheProduct.deals === "Deal"
                    //     ? 10
                    //     : TheProduct.deals === "Hit"
                    //     ? 10
                    //     : 0,
                    padding: TheProduct.deals !== "" ? 5 : 0,
                    paddingLeft: TheProduct.deals !== "" ? 10 : 0,
                    paddingRight: TheProduct.deals !== "" ? 10 : 0,
                    fontWeight: "bold",
                  }}
                >
                  {/* {TheProduct.deals === "Deal"
                    ? "D E A L"
                    : TheProduct.deals === "Hit"
                    ? "H I T"
                    : ""} */}
                  {/* {TheProduct.deals} */}
                  {TheProduct.deals === "ORIGINAL" ? (
                    <>{t("profile.original")}</>
                  ) : TheProduct.deals === "MASTER" ? (
                    <>{t("profile.master")}</>
                  ) : (
                    ""
                  )}
                </p>
              </div>

              {/* Heart icon changes color based on hover and click */}
              <div
                style={{
                  display: "flex",
                  padding: 10,
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FaHeart
                  // onMouseEnter={() => setIsHeartHovered(true)}
                  // onMouseLeave={() => setIsHeartHovered(false)}
                  onClick={() => {
                    console.log("aaaaaaaaa");
                    if (user === null) {
                      setOpenLoginPopOver(true);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    } else {
                      toggleWishlist();
                      const updatedClickedHearts = [...clickedHearts];
                      updatedClickedHearts[TheProduct.id] =
                        !updatedClickedHearts[TheProduct.id]; // Toggle heart state
                      setClickedHearts(updatedClickedHearts); // Update the heart clicked state
                    }
                  }} // Handle heart click
                  style={{
                    cursor: "pointer",
                    fontSize: "18px",
                    color:
                      theProductHover === null
                        ? CheckIfInWishList.some(
                            (item) => item.productId === TheProduct.id
                          )
                          ? "#4f46e5"
                          : "#ccc"
                        : CheckIfInWishList.some(
                            (item) => item.productId === theProductHover.id
                          )
                        ? "#4f46e5"
                        : "#ccc",
                    transition: "color 0.3s ease",
                  }}
                />
              </div>
            </div>

            {/* <div
              ref={wrapperRef2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                //height: "50vh", // Adjust as needed
              }}
            >
              <Carousel
                arrows={false}
                infinite={false}
                ref={carouselRef2}
                beforeChange={handleBeforeChange2}
                //dots={false}
                style={{
                  width: "100%", // Ensure the carousel takes full width
                  maxWidth: "400px", // Limit the carousel width
                }}
              >
                {ImagesOfProduct.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex !important", // Force flex display
                      justifyContent: "center !important", // Force horizontal centering
                      alignItems: "center !important", // Force vertical centering
                      height: "400px", // Set a fixed height for the slide
                      width: "100%", // Ensure the slide takes full width
                    }}
                  >
                    <img
                      src={ImagesOfProduct[index]}
                      alt={`Image ${index + 1}`}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain", // Ensure the full image is visible
                      }}
                      onClick={() => {
                        setImageUrlForZoom(ImagesOfProduct[index]);
                        setOpenImage(true);
                      }}
                    />
                  </div>
                ))}
              </Carousel>
            </div> */}
            {areImagesLoaded ? (
              <div
                ref={wrapperRef2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Carousel
                  arrows={false}
                  infinite={false}
                  ref={carouselRef2}
                  beforeChange={handleBeforeChange2}
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                  }}
                >
                  {ImagesOfProduct.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "400px",
                        width: "100%",
                      }}
                    >
                      <img
                        src={image}
                        alt={`Image ${index + 1}`}
                        style={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                        onClick={() => {
                          setImageUrlForZoom(image);
                          setOpenImage(true);
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            ) : (
              <div
                style={{
                  height: "400px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p>Loading images...</p>
              </div>
            )}

            <div
              style={{
                display: "flex",
                width: "100%",
                justifyItems: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  fontSize: 15,
                  margin: 0,
                  opacity: 0.5,
                  paddingTop: 20,
                }}
              ></p>
              <p style={{ fontSize: 26, fontWeight: "500", margin: 0 }}>
                {TheProduct.name}
              </p>

              <p
                style={{
                  fontSize: 15,
                  margin: 0,
                  opacity: 0.5,
                  paddingTop: 20,
                }}
              >
                {TheProduct.productType}
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {NumberUsersReview === 0 ? (
                  <></>
                ) : (
                  <>
                    <Rating
                      name="read-only"
                      value={ReviewsProduct}
                      readOnly
                      sx={{
                        // Make stars bigger
                        fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                        // Add space between stars
                        "& .MuiRating-icon": {
                          color: "black", // Black stars
                          paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                          paddingTop: 1,
                        },

                        // Ensure filled/hover stars are also black
                        "& .MuiRating-iconFilled": {
                          color: "black",
                        },
                        "& .MuiRating-iconHover": {
                          color: "black",
                        },
                      }}
                    />
                  </>
                )}
                {NumberUsersReview !== 0 ? (
                  <a style={{ fontSize: 14, paddingTop: 7 }}>
                    &nbsp; &nbsp;{NumberUsersReview} {t("profile.Reviews")}
                  </a>
                ) : (
                  <></>
                )}
              </div>
              <p
                style={{
                  fontSize: 15,
                  margin: 0,
                  opacity: 0.5,
                  paddingTop: 20,
                }}
              ></p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              //backgroundColor: "#cffafe",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBottom: 25,
              }}
            >
              {theProductHover === null ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {TheProduct.discount === 0 ? (
                    <>
                      {/* <a
                        style={{
                          margin: 0,
                          color: TheProduct.theDeal === 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          TheProduct.price,
                          1,
                          TheProduct.discount,
                          TheProduct.theDeal
                        )}
                      </a> */}

                      {TheProduct.priceInsteadOf === 0 ? (
                        <>
                          <a
                            style={{
                              margin: 0,
                              color: TheProduct.theDeal === 1 ? "" : "red",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              TheProduct.price,
                              1,
                              TheProduct.discount,
                              TheProduct.theDeal
                            )}
                          </a>
                        </>
                      ) : (
                        <>
                          <a
                            style={{
                              margin: 0,
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              TheProduct.price,
                              1,
                              TheProduct.discount,
                              TheProduct.theDeal
                            )}
                          </a>
                          &nbsp; {TheProduct.priceInsteadOf}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: TheProduct.theDeal !== 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          TheProduct.price,
                          1,
                          TheProduct.discount,
                          TheProduct.theDeal
                        )}
                      </a>
                    </>
                  )}
                  &nbsp;&nbsp;
                  <p style={{ margin: 0 }}>
                    {TheProduct.theDeal === 1 && TheProduct.discount !== 0 ? (
                      <>
                        {/* <a style={{ margin: 0 }}>
                          <a
                            style={{
                              margin: 0,
                              textDecoration:
                                TheProduct.discount === 0
                                  ? "none"
                                  : "line-through",
                              color: TheProduct.discount === 0 ? "" : "#a1a1aa",
                            }}
                          >
                            {TheProduct.price}
                          </a>
                          &nbsp;&nbsp;<a>{TheProduct.discount}</a>
                        </a> */}
                        <>
                          <a style={{ margin: 0 }}>
                            <a
                              style={{
                                margin: 0,
                                textDecoration:
                                  TheProduct.discount === 0
                                    ? "none"
                                    : "line-through",
                                color:
                                  TheProduct.discount === 0 ? "" : "#a1a1aa",
                              }}
                            >
                              {TheProduct.price.toFixed(2)}
                            </a>
                            &nbsp;&nbsp;{" "}
                            <a
                              style={{
                                backgroundColor: "#6b21a8",
                                color: "white",
                                fontSize: 12,
                                paddingLeft: 5,
                                paddingRight: 5,
                              }}
                            >
                              -{TheProduct.discount}%
                            </a>
                          </a>
                        </>
                      </>
                    ) : (
                      <></>
                    )}
                  </p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {theProductHover.discount === 0 ? (
                    <>
                      {/* <a
                        style={{
                          margin: 0,
                          color: theProductHover.theDeal === 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          theProductHover.price,
                          1,
                          theProductHover.discount,
                          theProductHover.theDeal
                        )}
                      </a> */}

                      {theProductHover.priceInsteadOf === 0 ? (
                        <a
                          style={{
                            margin: 0,
                            color: theProductHover.theDeal === 1 ? "" : "red",
                          }}
                        >
                          ₪
                          {calculateTotalPrice(
                            theProductHover.price,
                            1,
                            theProductHover.discount,
                            theProductHover.theDeal
                          )}
                        </a>
                      ) : (
                        <>
                          <a
                            style={{
                              margin: 0,
                              //color: theProductHover.theDeal === 1 ? "" : "red",
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            ₪
                            {calculateTotalPrice(
                              theProductHover.price,
                              1,
                              theProductHover.discount,
                              theProductHover.theDeal
                            )}
                          </a>
                          &nbsp;&nbsp;
                          {theProductHover.priceInsteadOf}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: theProductHover.theDeal !== 1 ? "" : "red",
                        }}
                      >
                        ₪
                        {calculateTotalPrice(
                          theProductHover.price,
                          1,
                          theProductHover.discount,
                          theProductHover.theDeal
                        )}
                      </a>
                    </>
                  )}
                  &nbsp;&nbsp;
                  <a style={{ margin: 0 }}>
                    {theProductHover.theDeal === 1 &&
                    theProductHover.discount !== 0 ? (
                      <>
                        <a
                          style={{
                            margin: 0,
                            textDecoration:
                              theProductHover.discount === 0
                                ? "none"
                                : "line-through",
                            color:
                              theProductHover.discount === 0 ? "" : "#a1a1aa",
                          }}
                        >
                          {theProductHover.price}
                        </a>
                        &nbsp;&nbsp;<a>{theProductHover.discount}</a>
                      </>
                    ) : (
                      <></>
                    )}
                  </a>
                </div>
              )}
            </div>
            <div
              style={{ display: "flex", overflowX: "auto", paddingBottom: 20 }}
            >
              {productDropDowns1.length > 1 ? (
                <>
                  {productDropDowns1.map((product, index) => (
                    <div
                      key={product.id}
                      style={{
                        //padding: "5px 10px",

                        paddingLeft: 30,
                        paddingRight: 30,
                        cursor: "pointer",
                        border:
                          MobileColorDropDownButton === index
                            ? "1px solid black"
                            : "1px solid #e4e4e7",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 40,
                      }}
                      onClick={() => {
                        setMobileColorDropDownButton(index);
                        handleButtonClick3(index);
                        handleOptionClick(product.dropDown);
                        setTheProduct(product);
                        handleButtonClick(index);
                        handleButtonClick2(index);
                        setSaveIndexFromDropDown(index);
                      }}
                    >
                      <img
                        key={index}
                        src={ImagesOfProduct[index]}
                        alt={`Image ${product.img}`}
                        style={{
                          width: 20,
                          height: 20,
                          objectFit: "cover",
                        }}
                      />
                      {product.dropDown}
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
            <div
              style={{
                padding: "1px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "transform 0.3s ease, opacity 0.3s ease",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {DoLoading2 ? (
                <>
                  {TheProduct.isGift === 2 ? (
                    <button
                      style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        handleDivClick3(TheProduct.newsCodeCat);
                      }}
                    >
                      Receive as a gift
                    </button>
                  ) : (
                    <button
                      style={{
                        backgroundColor: "#27272a",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        user === null ? setBuyNotLogin(true) : CreateProduct();
                      }}
                    >
                      {LoadingClickBuyButton ? (
                        <>
                          {" "}
                          <Lottie
                            style={{ height: 30, width: 30 }}
                            animationData={LottifileLoading}
                          />
                        </>
                      ) : (
                        <>{t("profile.Buy")}</>
                      )}
                    </button>
                  )}
                </>
              ) : (
                <>
                  <Lottie
                    style={{ height: 30, width: 30 }}
                    animationData={LottifileLoading}
                  />
                </>
              )}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingTop: 10,
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              <p style={{ margin: 0 }}>
                {theProductHover === null ? (
                  <>
                    {TheProduct.inStock === "Yes" ? (
                      <>
                        <a style={{ fontSize: 13 }}>{t("profile.InStock")}</a>{" "}
                      </>
                    ) : (
                      <>
                        <a>{t("profile.Outofstock")}</a>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {theProductHover.inStock === "Yes" ? (
                      <>
                        <a>{t("profile.InStock")}</a>{" "}
                      </>
                    ) : (
                      <>
                        <a>{t("profile.Outofstock")}</a>
                      </>
                    )}
                  </>
                )}
              </p>

              <a
                style={{
                  fontSize: 13,
                  paddingRight: 2,
                  direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
                }}
              >
                {t("profile.productID")}&nbsp;
                <a style={{ color: "#a1a1aa" }}>{ProductId2}</a>
              </a>
            </div>
            <a
              style={{
                fontSize: 13,
                paddingTop: 15,
                color: "#6b21a8",
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              {t("profile.Freedeleviryover")}
            </a>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: 50,
            //padding: 30,
          }}
        >
          <div
            style={{
              width: "100%",
              paddingBottom: 20,
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <a style={{ fontWeight: "500" }}>{t("profile.Characteristics")}</a>
            {/* <a>Description</a> */}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",

              maxHeight: "300px", // Set maximum height for the dropdown
              overflowY: "auto", // Enable vertical scroll
            }}
          >
            {TheProduct.brand !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Brand")}: </a>
                {TheProduct.brand}
              </a>
            ) : (
              ""
            )}
            {TheProduct.gender !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Gender")}: </a>
                {TheProduct.gender}
              </a>
            ) : (
              ""
            )}
            {TheProduct.topNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.TopNote")}: </a>
                {TheProduct.topNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.productType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProductType")}:{" "}
                </a>
                {TheProduct.productType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.classfication !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.Classification")}:{" "}
                </a>
                {TheProduct.classfication}
              </a>
            ) : (
              ""
            )}
            {TheProduct.productProperties !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProductProperties")}:{" "}
                </a>
                {TheProduct.productProperties}
              </a>
            ) : (
              ""
            )}
            {TheProduct.scentType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.ScentType")}: </a>
                {TheProduct.scentType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.heartNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.HeartNote")}: </a>
                {TheProduct.heartNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.baseNote !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.BaseNote")}: </a>
                {TheProduct.baseNote}
              </a>
            ) : (
              ""
            )}
            {TheProduct.ingredients !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.Ingredients")}:{" "}
                </a>
                {TheProduct.ingredients}
              </a>
            ) : (
              ""
            )}
            {TheProduct.specialCertificates !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.SpecialCertificates")}:{" "}
                </a>
                {TheProduct.specialCertificates}
              </a>
            ) : (
              ""
            )}
            {TheProduct.volume !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Volume")}: </a>
                {TheProduct.volume}
              </a>
            ) : (
              ""
            )}
            {TheProduct.madeIn !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.MadeIn")}: </a>
                {TheProduct.madeIn}
              </a>
            ) : (
              ""
            )}
            {TheProduct.color !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Color")}: </a>
                {TheProduct.color}
              </a>
            ) : (
              ""
            )}
            {TheProduct.protectionLevel !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.ProtectionLevel")}:{" "}
                </a>
                {TheProduct.protectionLevel}
              </a>
            ) : (
              ""
            )}
            {TheProduct.eyeshadowEffect !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.EyeshadowEffect")}:{" "}
                </a>
                {TheProduct.eyeshadowEffect}
              </a>
            ) : (
              ""
            )}
            {TheProduct.formula !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Formula")}: </a>
                {TheProduct.formula}
              </a>
            ) : (
              ""
            )}
            {TheProduct.country !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Country")}: </a>
                {TheProduct.country}
              </a>
            ) : (
              ""
            )}
            {TheProduct.hairType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.HairType")}: </a>
                {TheProduct.hairType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.brushMaterial !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>
                  {t("filters.BrushMaterial")}:{" "}
                </a>
                {TheProduct.brushMaterial}
              </a>
            ) : (
              ""
            )}
            {TheProduct.skinType !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.SkinType")}: </a>
                {TheProduct.skinType}
              </a>
            ) : (
              ""
            )}
            {TheProduct.age !== "" ? (
              <a>
                <a style={{ fontWeight: "500" }}>{t("filters.Age")}: </a>
                {TheProduct.age}
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  };

  function RatingModalFunc() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog3
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={OpenRateProductDialog}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginRight: 10,
                marginTop: 10,
              }}
            >
              <img
                onClick={() => {
                  setOpenRateProductDialog(false);
                }}
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <a style={{ fontWeight: 500, fontSize: 25, marginBottom: 20 }}>
                {TheProduct.name} - {TheProduct.productType}
              </a>
              <a style={{ fontWeight: 500, marginBottom: 10 }}>
                {t("profile.Yourrating")}
              </a>
              <Box sx={{ "& > legend": { mt: 2 } }}>
                <Rating
                  name="simple-controlled"
                  value={value}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                  }}
                  sx={{
                    // Make stars bigger
                    fontSize: "2rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                    // Add space between stars
                    "& .MuiRating-icon": {
                      color: "black", // Black stars
                      padding: "0 15px", // Adjust spacing (e.g., 0 8px for more space)
                    },

                    // Ensure filled/hover stars are also black
                    "& .MuiRating-iconFilled": {
                      color: "black",
                    },
                    "& .MuiRating-iconHover": {
                      color: "black",
                    },
                  }}
                />
              </Box>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: MyWidth <= 1024 ? "90%" : "80%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    id="standard-basic"
                    label={t("profile.email")}
                    variant="standard"
                    style={{
                      paddingBottom: 30,
                      width: MyWidth <= 1024 ? "45%" : "45%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
                    }}
                    value={FirstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#a1a1aa", // Default color for bottom line
                        opacity: 0.5,
                        borderBottomWidth: "1px", // Thin bottom line
                      },
                      "& .MuiInput-underline:hover:before": {
                        borderBottomColor: "#a1a1aa", // Keep it gray on hover
                        opacity: 0.8,
                        borderBottomWidth: "1px", // Keep it thin on hover
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#6366f1", // Change to yellow on focus
                        borderBottomWidth: "1px", // Keep it thin when focused
                      },
                      "& .MuiInputBase-root": {
                        //color: "#a1a1aa", // Color of the text in the input field
                        fontSize: "14px", // Set font size of entered value to 14px
                      },
                    }}
                  />
                  <TextField
                    id="standard-basic"
                    label={t("profile.email")}
                    variant="standard"
                    style={{
                      paddingBottom: 30,
                      width: MyWidth <= 1024 ? "45%" : "45%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
                    }}
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "#a1a1aa", // Default color for bottom line
                        opacity: 0.5,
                        borderBottomWidth: "1px", // Thin bottom line
                      },
                      "& .MuiInput-underline:hover:before": {
                        borderBottomColor: "#a1a1aa", // Keep it gray on hover
                        opacity: 0.8,
                        borderBottomWidth: "1px", // Keep it thin on hover
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#6366f1", // Change to yellow on focus
                        borderBottomWidth: "1px", // Keep it thin when focused
                      },
                      "& .MuiInputBase-root": {
                        //color: "#a1a1aa", // Color of the text in the input field
                        fontSize: "14px", // Set font size of entered value to 14px
                      },
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    width: MyWidth <= 1024 ? "90%" : "80%",
                    justifyContent: "flex-start",
                  }}
                >
                  <a style={{ fontSize: 14 }}>
                    {t("profile.Youcanleavearevieworaskaquestion")}
                  </a>
                </div>
                <TextField
                  id="standard-multiline-static"
                  label={t("profile.Messagetext")}
                  multiline
                  rows={4}
                  //defaultValue="Default Value"
                  variant="standard"
                  style={{
                    paddingBottom: 20,
                    width: MyWidth <= 1024 ? "90%" : "80%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
                  }}
                  sx={{
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#a1a1aa", // Default color for bottom line
                      opacity: 0.5,
                      borderBottomWidth: "1px", // Thin bottom line
                    },
                    "& .MuiInput-underline:hover:before": {
                      borderBottomColor: "#a1a1aa", // Keep it gray on hover
                      opacity: 0.8,
                      borderBottomWidth: "1px", // Keep it thin on hover
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#6366f1", // Change to yellow on focus
                      borderBottomWidth: "1px", // Keep it thin when focused
                    },
                    "& .MuiInputBase-root": {
                      //color: "#a1a1aa", // Color of the text in the input field
                      fontSize: "14px", // Set font size of entered value to 14px
                    },
                  }}
                  onChange={(e) => setTheText(e.target.value)} // Update state on input change
                  value={TheText}
                />
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    CreateReviewsFunc();
                    //setOpenRateProductDialog(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Done")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog3>
        </React.Fragment>
      </div>
    );
  }

  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={openDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            {/* <IconButton
                aria-label="close"
                onClick={handleClose2}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              ></IconButton> */}

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>Thanks for your time rating our products.</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    // const [openDone, setOpenDone] = React.useState(false);
                    setOpenDone(false);
                    setOpenRateProductDialog(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Done")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }
  const CreateReviewsFunc = async () => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    // Format time
    const time = `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}`;

    const firstNumber = parseInt(
      TheProduct.bigCategoryFilter.split(",")[0].trim(),
      10
    );

    const data = {
      UserId: user === null ? 0 : user?.userId,
      ProductId: ProductId,
      ProductSpecificId: ProductId,
      NameCat: TheProduct.category,
      Comment: TheText,
      TheDate: formattedDate,
      TheTime: time,
      CodeCat: firstNumber, // get it from bigcategoryfilter
      Rating: value,
      FullName: FirstName,
      Email: Email,
      Approved: 0,
    };
    console.log(data);
    try {
      const response = await axios.post(
        `${MyDomain}Reviews/CreateReviews`,
        data
      );
      setOpenDone(true);
      setValue(0);
      setTheText("");

      console.log(response.data);
    } catch (err) {
      console.log(err.response.data);
    }
  };

  return (
    <div>
      {ModalBuyNotLogin()}
      {ModalOpenImage()}
      <AllCategoriesCartDialog
        MyOpen={MyOpen}
        onClose={handleCloseDialog}
        CartData={CartData}
        MySaveTotalPrice={SaveTotalPrice}
        onCreateProduct2={CreateProduct2}
        handleDivClick2={handleDivClick2}
        MyRecommendedProductsData={RecommendedProductsData}
      />
      {MyWidth <= 1024 ? <>{MobileForm()}</> : <>{WindowsForm()}</>}

      {SimilarProductsCompComp}

      {AllCategoriesRecentlyViewedComp}

      {DoLoading ? <PerfumeBlockTwoCards CardData={GetCards} /> : <></>}

      {RatingModalFunc()}
      {ModalDone()}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          marginTop: 50,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <a style={{ fontWeight: 500, fontSize: 25, marginBottom: 20 }}>
          {TheProduct.name} - {TheProduct.productType}
        </a>
        <button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#27272a",
            color: "white",
            border: "none",
            //padding: "10px 20px",
            padding: 12,

            cursor: "pointer",
            width: MyWidth >= 1024 ? "30%" : "60%",
          }}
          // onClick={() => {
          //   setOpen(true);
          // }}
          onClick={() => {
            setOpenRateProductDialog(true);
          }}
        >
          <a style={{ fontSize: 14 }}>
            {t("profile.LeaveyourcommentAskaaquestion")}
          </a>
        </button>
        <ProductDiscReviews ListOfUsersReview={ListOfUsersReview} />
      </div>
    </div>
  );
}
